/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DashboardOverviewResponse = zod
	.object({
		praetor_summary: zod.array(
			zod
				.object({
					praetor_id: zod.string().describe('Praetor ID'),
					total_cases: zod.number().describe('Cases processed by this praetor'),
					violations: zod.number().describe('Violations detected by this praetor')
				})
				.describe('Per-praetor case breakdown')
		),
		timeseries: zod.array(
			zod
				.object({
					compliant: zod.number().describe('Cases that passed compliance'),
					total_cases: zod.number().describe('Total moderation cases'),
					ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp'),
					violations: zod.number().describe('Cases flagged as violations')
				})
				.describe('Moderation timeseries data point')
		),
		totals: zod
			.object({
				total_cases: zod.number().describe('Total cases in range'),
				violations: zod.number().describe('Total violations in range')
			})
			.describe('Moderation summary totals')
	})
	.describe('Dashboard overview with totals, timeseries, and praetor breakdown');

export type DashboardOverviewResponse = zod.input<typeof DashboardOverviewResponse>;
export type DashboardOverviewResponseOutput = zod.output<typeof DashboardOverviewResponse>;
